import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { HttpClientService } from '../implementacion/http-client.service';
import { UsuarioEscenario } from 'src/app/models/SicarMap/Escenario/UsuarioEscenario.model';
import { Escenarios } from '../../models/SicarMap/Escenario/Escenarios.modelo';


@Injectable({
    providedIn: 'root'
  })

export class EscenariosService {
  constructor( private http: HttpClientService ) { }

  getConfiguracionEscenario(Id: number) {
    return this.http.get(`${environment.apiScar}Escenario/ObtenerConfigScene?Clave=` + Id)
      .pipe(map(response => response));
  }

  getEscenarios(Id: number) {
    return this.http.get(`${environment.apiScar}Escenario/ObtenerEscenarios?ClaveUsuario=` + Id)
      .pipe(map(response => response));
  }

  getUsuarios(IdUsuario: number) {
    return this.http.get(`${environment.apiScar}Escenario/ObtenerUsuariosScene?ClaveUsuario=` + IdUsuario)
    .pipe(map(response => response ));
  }

  ShareEscenario(usuarios: UsuarioEscenario[]) {
    return this.http.post(`${environment.apiScar}Escenario/CompartirEscenarioUsr`, usuarios)
    .pipe(map(response => response ));
  }

  DeleteUserScener(claveRUS: number) {
    return this.http.post(`${environment.apiScar}Escenario/EliminarSceneUser`, claveRUS)
    .pipe(map(response => response ));
  }

  AddScene( escenario: Escenarios) {
    return this.http.post(`${environment.apiScar}Escenario/AgregarEscenario`, escenario)
    .pipe(map(response => response ));
  }

  DeleteScene( ClaveU: number, ClaveS: number) {
    return this.http.get(`${environment.apiScar}Escenario/EliminarEscenario?ClaveUsuario=` + ClaveU + '&ClaveScene=' + ClaveS)
    .pipe(map(response => response ));
  }
}
